import { Pipe, PipeTransform, ElementRef, ChangeDetectorRef } from '@angular/core';
import { DecimalPipe, CurrencyPipe, PercentPipe } from '@angular/common';
import { DomSanitizer } from '@angular/platform-browser';
import { SharedService } from './service';

import * as _ from 'lodash';
import { TranslateService, TranslatePipe } from '@ngx-translate/core';

declare var moment: any;
declare var jQuery: any;
declare var $: any;

// tslint:disable:max-classes-per-file
// tslint:disable:pipe-naming
// tslint:disable:switch-default

@Pipe({
  name: 'Sanitize'
})
export class Sanitize implements PipeTransform {
  constructor(
    private _sanitizer: DomSanitizer
  ) { }
  public transform(value: string, type: 'url' | 'html'): any {
    switch (type) {
      case 'html': return this._sanitizer.bypassSecurityTrustHtml(value);
      case 'url': return this._sanitizer.bypassSecurityTrustUrl(value);
    }
  }
}

@Pipe({
  name: 'DynamicCurrency',
  pure: false
})
export class DynamicCurrency implements PipeTransform {

  public transform(value: number, output: 'default' | 'symbol' | 'iconClass' = 'default'): any {
    const shared = SharedService.getInstance();
    const r = (new CurrencyPipe('en')).transform((value || 0), shared.currency, true, '1.2-2');
    if (output === 'symbol') { return r.replace(/^([^\d]+).*$/, '$1').trim(); }
    return r;
  }
}

@Pipe({
  name: 'NumberLocalized'
})
export class NumberLocalized implements PipeTransform {

  transform(val: number, locale: 'string' ): string {     
     if (val !== undefined && val !== null && locale ) {
        return Intl.NumberFormat(locale).format(val)        
     } else {
        return '';
     }
  }
}

@Pipe({
  name: 'NumberTranslator'
})
export class NumberTranslator implements PipeTransform {
  constructor(private _currencyPipe: DynamicCurrency) { }

  public transform(value, type: 'number' | 'percentage' | 'currency' | string): string | number {
    switch (type) {
      case 'number': return new DecimalPipe('en').transform(value);
      case 'currency': return this._currencyPipe.transform(value);
      case 'percentage': return new PercentPipe('en').transform(value, '1.2-2');
      default: return value;
    }
  }
}

@Pipe({
  name: 'CalculateTime',
  pure: false
})
export class CalculateTime implements PipeTransform {
  public transform(value): string {
    if (!value) { return ''; }
    return moment(value).fromNow(true).concat(' ', moment(value).diff(moment(), 'seconds') > 0 ? 'left' : 'ago');
  }
}

@Pipe({
  name: 'CdnBaseURL',
  pure: false
})
export class CdnBaseURL implements PipeTransform {
  public transform(urlOrPath: string): string {
    let baseURL = '';
    const mapCdnBaseURLs = new Map<string | RegExp, string>([
      // [/^localhost$/i, 'http://i.adv.hera.pe'],
      // ['localhost', 'http://i.adv.hera.pe'],
      // [/^.*$/, 'https://advstatic.bksn.se'],
    ]);
    const fnLoadCdnBaseUrlByDomain = () => {
      // abort if urlpath not start with /assets/
      if (!/^\/assets\/.*/i.test(urlOrPath) || (ENV === 'development')) { return; }

      if (mapCdnBaseURLs.size > 0) {
        mapCdnBaseURLs.forEach((cdnUrl, matcher) => {
          if (
            ((matcher instanceof RegExp && matcher.test(window.location.hostname)) || matcher === window.location.hostname) && // if hostname exists in config
            /^\/assets\/.*/i.test(urlOrPath) && // if url start with /assets/
            baseURL.length === 0 // if not founded baseUrl
          ) {
            baseURL = cdnUrl;
          }
        });
      }

      if (baseURL.length === 0) {
        baseURL = 'https://advstatic.bksn.se';
      }
    };
    if (!/^(beta|stable|local(host?)|anthonye|cleliaf)/.test(window.location.hostname)) { // exclude local, stable and beta environments
      fnLoadCdnBaseUrlByDomain();
    }
    return `${baseURL}${urlOrPath}`;
  }
}


@Pipe({
  name: 'TextPlain',
  pure: false
})
export class TextPlainPipe implements PipeTransform {
  private static HTMLTAGS_REGEX = [
    /<[^>]*>/g, // tags open & closed
    /<[^\s]*\s+/g, // tag open without close tag
    /(<|\/?>)/g, // any char like as open tag & close tag
  ];
  public transform(value: string): string {
    return TextPlainPipe.HTMLTAGS_REGEX.reduce((r, regx) => r.replace(regx, ''), _.cloneDeep(value || ''));
  }

  public static canBeReduced(value:string): boolean {
    return !!_.find(TextPlainPipe.HTMLTAGS_REGEX, (regx) => regx.test(value));;
    // console.debug('%s ->  canBeReduced: %s', value, canBeReduced ? 'Y' : 'N');
    // return canBeReduced;
  }
}

@Pipe({
  name: 'ObjNgFor',
  pure: false
})
export class ObjNgFor implements PipeTransform {
  public transform(entry: { [k: string]: any }): Array<{ value: string; key: string; }> {
    return _.reduce(entry, (r, value, key) => _.concat(r, { key, value }), []);
  }
}

@Pipe({
  name: 'SortBy',
  pure: false
})
export class SortBy implements PipeTransform {
  public transform(entry: any[], filter: string[]): any[] {
    return _.sortBy(entry, filter);
  }
}

@Pipe({
  name: 'Filter',
  pure: false
})
export class Filter implements PipeTransform {
  public transform(entry: any[], filter): any[] {
    return _.filter(entry, filter);
  }
}

@Pipe({
  name: 'translate',
  pure: false
})
export class ExtendedTranslatePipe implements PipeTransform {
  constructor(
    private el: ElementRef, private translate: TranslateService, private _ref: ChangeDetectorRef,
  ) {

  }
  public transform(query: string, ...args: any[]): any {
    if ($(this.el.nativeElement).attr('i18neditor') !== 'on') {
      $(this.el.nativeElement).attr('i18neditor', 'on').attr('key', query);
    }
    return new TranslatePipe(this.translate, this._ref).transform(query, ...args);
  }
}

@Pipe({ name: 'BillingTransactionView', pure: false })
export class BillingTransactionView implements PipeTransform {

  public transform(items: any[]): any {
    const shared = SharedService.getInstance();
    let bliingTransactionView = [];
    if (!items) {
      return;
    }

    if (shared.account.role == 'member') {
      // items.forEach((transaction: any) => {
      //   if (transaction.user_role == 'member' && (transaction.payment_type_id == 1 || transaction.payment_type_id == 3 || transaction.payment_type_id == 5))
      //     bliingTransactionView.push(transaction);
      //   else if (transaction.user_role == 'advertiser' && (transaction.payment_type_id == 3 || transaction.payment_type_id == 5))
      //     bliingTransactionView.push(transaction);
      // });
      // console.log("bliingTransactionView >> ", bliingTransactionView)
      // return bliingTransactionView;

      return items.map((transaction) => {
        const hidden = (() => {
          if (
            (transaction.user_role === 'member' && [1, 3, 5].indexOf(transaction.payment_type_id) > -1) ||
            (transaction.user_role === 'advertiser' && [3, 5].indexOf(transaction.payment_type_id) > -1)
          ) { return false; }
          return true;
        })();
        return _.assign({}, transaction, { hidden });
      });
    }
    else {
      return items;
    }
  }
}

export const COMMON_PIPE_PROVIDERS = [
  Sanitize,
  NumberTranslator,
  NumberLocalized,
  CalculateTime,
  CdnBaseURL,
  DynamicCurrency,
  ObjNgFor,
  Filter,
  SortBy,
  BillingTransactionView,
  TextPlainPipe,
  // ExtendedTranslatePipe,
  // {
  //   provide: DynamicCurrency,
  //   useFactory: (currencyPipe: CurrencyPipe, sharedService: SharedService) => new DynamicCurrency(currencyPipe, sharedService),
  //   deps: [CurrencyPipe, SharedService]
  //  }
];



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/common/pipe.ts